import React, { ReactNode } from "react";

import { EmptyContainer } from "src/components/emptyContainer";

interface ErrorBoundaryProps {
  readonly message?: string;
  readonly children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <EmptyContainer text={this.props.message || "Page not found."} />;
    }
    return this.props.children;
  }
}
